<template>
  <div class="ovg-page">
    <div class="ovg-page__bg" aria-hidden="true" />

    <header class="ovg-header">
      <div
        class="ovg-header__logos"
        @click="$router.push({ name: 'ovg-landing' })"
      >
        <img
          src="@/assets/logo_original.svg"
          alt="Samtek"
          class="ovg-header__logo-samtek"
        />
        <img
          src="@/assets/logo_asus.png"
          alt="ASUS"
          class="ovg-header__logo-asus"
        />
      </div>
      <button
        class="ovg-header__salir"
        @click="$router.push({ name: 'ovg-landing' })"
      >
        Salir <font-awesome-icon icon="sign-out-alt" />
      </button>
    </header>

    <div class="ovg-subheader">
      <div class="ovg-subheader__inner">
        <h2 class="ovg-subheader__title">
          Adquiere tu Extensión de Garantía Oficial
        </h2>
        <p class="ovg-subheader__subtitle">
          Protege tu equipo contra fallas técnicas y extiende su vida útil.<br />
          Elige el plan que mejor se adapte a tus necesidades.
        </p>
      </div>
    </div>

    <div class="ovg-content">
      <div class="ovg-card">
        <!-- Mobile progress bar (hidden on desktop) -->
        <div class="ovg-progress">
          <div class="ovg-progress__track">
            <div class="ovg-progress__fill" style="width: 75%" />
          </div>
          <span class="ovg-progress__label"
            >Paso Actual: Extensión Garantía</span
          >
        </div>

        <!-- Step indicator (hidden on mobile) -->
        <div class="ovg-steps">
          <div class="ovg-step ovg-step--done">
            <span class="ovg-step__num">1</span>
            <span class="ovg-step__label">Tus Datos</span>
          </div>
          <div class="ovg-step ovg-step--done">
            <span class="ovg-step__num">2</span>
            <span class="ovg-step__label">Tu Equipo</span>
          </div>
          <div class="ovg-step ovg-step--active">
            <span class="ovg-step__num">3</span>
            <span class="ovg-step__label">Ext. Garantía</span>
          </div>
          <div class="ovg-step" :class="{ 'ovg-step--muted': equipoAntiguo }">
            <span class="ovg-step__num">4</span>
            <span class="ovg-step__label">Protección Adicional</span>
          </div>
        </div>

        <div class="ovg-catalogo__intro">
          <h3 class="ovg-catalogo__title">
            Selecciona tu Extensión de Garantía
          </h3>
        </div>

        <div
          v-if="
            !loading &&
            !error &&
            !garantiaExpirada &&
            baseWarrantyYears !== null
          "
          class="ovg-info-box"
        >
          <font-awesome-icon icon="shield-alt" class="ovg-info-box__icon" />
          <span>
            Tu equipo tiene {{ baseWarrantyYears }} año(s) de garantía base
            activa.
          </span>
        </div>

        <div v-if="loading" class="ovg-catalogo__estado">
          <span class="ovg-spinner" />
          Cargando extensiones disponibles...
        </div>

        <div v-else-if="error" class="ovg-info-box">
          <font-awesome-icon
            icon="exclamation-triangle"
            class="ovg-info-box__icon ovg-info-box__icon--warn"
          />
          <span>No se pudieron cargar las extensiones disponibles.</span>
          <button type="button" class="ovg-link-btn" @click="cargarExtensiones">
            Reintentar
          </button>
        </div>

        <div v-else-if="garantiaExpirada" class="ovg-sin-garantias">
          <font-awesome-icon
            icon="exclamation-triangle"
            class="ovg-estado__icon ovg-estado__icon--warning"
          />
          <h3 class="ovg-estado__titulo">
            La garantía base de tu equipo ya expiró
          </h3>
          <p class="ovg-estado__texto">
            Hemos detectado que el equipo con S/N
            <strong>{{ numeroSerieEquipo }}</strong> ya no cuenta con garantía
            base vigente, por lo que no es posible adquirir extensiones ni
            protecciones adicionales en este momento.
          </p>
          <!-- Botón de contacto a soporte: oculto hasta definir a dónde debe
        apuntar (no sabemos el destino aún).
        <button type="button" class="ovg-btn ovg-btn--primary">
          Contactar Soporte
        </button>
        -->
          <button
            type="button"
            class="ovg-link-text"
            @click="$router.push({ name: 'ovg-modelo' })"
          >
            Volver al catálogo
          </button>
        </div>

        <div v-else-if="extensiones.length === 0" class="ovg-sin-garantias">
          <font-awesome-icon
            icon="shield-alt"
            class="ovg-sin-garantias__icon"
          />
          <p class="ovg-sin-garantias__text">
            No hay extensiones disponibles para este modelo por el momento.
          </p>
          <button
            type="button"
            class="ovg-btn ovg-btn--secondary"
            @click="$router.push({ name: 'ovg-modelo' })"
          >
            Volver a buscar otro modelo
          </button>
        </div>

        <template v-else>
          <div class="ovg-catalogo__grid">
            <div
              v-for="g in extensiones"
              :key="g.id"
              class="ovg-garantia-card"
              :class="{
                'ovg-garantia-card--selected': selectedId === g.id,
                'ovg-garantia-card--muted':
                  (selectedId !== null && selectedId !== g.id) || sinExtension,
              }"
              @click="seleccionar(g)"
            >
              <img
                src="@/assets/icons/timer-sand-full.svg"
                alt=""
                class="ovg-garantia-card__icon"
              />
              <span class="ovg-garantia-card__nombre">{{ g.nombre }}</span>
              <span class="ovg-garantia-card__desc">{{
                g.descripcion || g.vigencia_meses + ' meses de cobertura'
              }}</span>
              <span class="ovg-garantia-card__precio">{{
                formatPrecio(g.precio)
              }}</span>
              <button
                type="button"
                class="ovg-btn ovg-btn--primary ovg-garantia-card__btn"
                :aria-pressed="selectedId === g.id"
                @click.stop="seleccionar(g)"
              >
                {{
                  selectedId === g.id ? 'Seleccionado' : 'Agregar al Carrito'
                }}
              </button>
            </div>
          </div>

          <div
            class="ovg-sin-extension"
            :class="{
              'ovg-sin-extension--disabled': equipoAntiguo,
              'ovg-sin-extension--selected': sinExtension,
            }"
            @click="seleccionarSinExtension"
          >
            <svg-icon
              type="mdi"
              :path="mdiShieldOff"
              :size="24"
              class="ovg-sin-extension__icon"
            />
            <span class="ovg-sin-extension__nombre">
              Sin Extensión de Garantía
            </span>
            <span class="ovg-sin-extension__desc">
              Continuar solo con la garantía original de fábrica. Podrás
              seleccionar protecciones adicionales en el siguiente paso.
            </span>
            <button
              type="button"
              class="ovg-btn ovg-btn--primary ovg-sin-extension__btn"
              :disabled="equipoAntiguo"
              @click.stop="seleccionarSinExtension"
            >
              {{ sinExtension ? 'Seleccionado' : 'Seleccionar esta Opción' }}
            </button>
            <span v-if="equipoAntiguo" class="ovg-sin-extension__tooltip">
              {{ tooltipNoExt }}
            </span>
          </div>

          <p class="ovg-catalogo__recuerda">
            <span class="ovg-catalogo__recuerda-strong">*Recuerda:</span>
            Solo se puede agregar una (1) extensión de garantía por equipo.
          </p>

          <div class="ovg-card__footer ovg-card__footer--split">
            <button
              type="button"
              class="ovg-btn ovg-btn--secondary"
              @click="$router.push({ name: 'ovg-modelo' })"
            >
              Volver
            </button>
            <button
              type="button"
              class="ovg-btn ovg-btn--primary"
              :disabled="!puedeContinuar"
              @click="siguiente"
            >
              Siguiente Paso
            </button>
          </div>
        </template>
      </div>

      <resumen-solicitud-panel />
    </div>

    <!-- Mobile bottom bar + sheet (hidden on desktop) -->
    <ovg-resumen-mobile-bar />

    <!-- Botón de contacto WhatsApp: oculto hasta que el negocio lo habilite
    <a
      href="https://wa.me"
      class="ovg-contact-btn"
      target="_blank"
      rel="noopener"
    >
      <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
        <path :d="waSvgPath" />
      </svg>
    </a>
    -->

    <p class="ovg-page__footer">
      © 2026 Samtek | Servicio Técnico ASUS Autorizado en Chile.
    </p>
  </div>
</template>

<script>
import ResumenSolicitudPanel from '@/components/OVG/ResumenSolicitudPanel.vue'
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiShieldOff } from '@mdi/js'
import OvgResumenMobileBar from '@/components/OVG/OvgResumenMobileBar.vue'

export default {
  name: 'CatalogoView',
  components: {
    ResumenSolicitudPanel,
    SvgIcon,
    OvgResumenMobileBar,
  },
  data() {
    return {
      mdiShieldOff,
      waSvgPath:
        // eslint-disable-next-line max-len
        'M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z',
      extensiones: [],
      selectedId: null,
      selectedGarantia: null,
      sinExtension: false,
      loading: false,
      error: false,
      garantiaExpirada: false,
      baseWarrantyYears: null,
      tooltipNoExt:
        'Tu equipo tiene más de 180 días desde la compra. Por políticas de ' +
        'cobertura, debes seleccionar al menos una extensión de garantía para continuar.',
    }
  },
  computed: {
    puedeContinuar() {
      return !!this.selectedId || this.sinExtension
    },
    fechaCompraEquipo() {
      return this.$store.getters['OVGStore/fechaCompraEquipo']
    },
    numeroSerieEquipo() {
      const equipo = this.$store.getters['OVGStore/equipo']
      return equipo ? equipo.numero_serie : ''
    },
    // Días transcurridos desde la compra del equipo (regla de 180 días).
    diasDesdeCompra() {
      if (!this.fechaCompraEquipo) return null
      const compra = new Date(`${this.fechaCompraEquipo}T00:00:00`)
      const hoy = new Date()
      return Math.floor((hoy - compra) / (1000 * 60 * 60 * 24))
    },
    equipoAntiguo() {
      return this.diasDesdeCompra !== null && this.diasDesdeCompra > 180
    },
  },
  created() {
    const equipo = this.$store.getters['OVGStore/equipo']
    if (!equipo || !equipo.modelo_id || !this.fechaCompraEquipo) {
      this.$router.replace({ name: 'ovg-modelo' })
      return
    }
    this.cargarExtensiones()
  },
  methods: {
    cargarExtensiones() {
      const equipo = this.$store.getters['OVGStore/equipo']
      if (!equipo || !equipo.modelo_id) return
      this.loading = true
      this.error = false
      this.$store
        .dispatch('OVGStore/fetchExtensiones', {
          modeloId: equipo.modelo_id,
          fechaCompraEquipo: this.fechaCompraEquipo,
        })
        .then((data) => {
          this.extensiones = (data && data.extensiones) || []
          this.garantiaExpirada = !!(data && data.garantia_expirada)
          const anios = data && data.base_warranty_years
          this.baseWarrantyYears = anios === undefined ? null : anios
          const stored = this.$store.getters['OVGStore/extension']
          if (stored) {
            const match = this.extensiones.find((g) => g.id === stored.id)
            if (match) {
              this.selectedId = match.id
              this.selectedGarantia = match
            }
          }
        })
        .catch(() => {
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    seleccionar(garantia) {
      // Máx. 1 extensión por equipo: al elegir una se deshabilitan las demás.
      // Clic sobre la ya seleccionada la deselecciona (reactiva el resto).
      if (this.selectedId === garantia.id) {
        this.selectedId = null
        this.selectedGarantia = null
        return
      }
      this.selectedId = garantia.id
      this.selectedGarantia = garantia
      this.sinExtension = false
    },
    seleccionarSinExtension() {
      if (this.equipoAntiguo) return
      this.sinExtension = !this.sinExtension
      if (this.sinExtension) {
        this.selectedId = null
        this.selectedGarantia = null
      }
    },
    siguiente() {
      if (this.sinExtension) {
        if (this.equipoAntiguo) return
        this.$store.commit('OVGStore/SET_EXTENSION', null)
        this.$router.push({ name: 'ovg-protecciones' })
        return
      }
      if (!this.selectedGarantia) return
      this.$store.commit('OVGStore/SET_EXTENSION', this.selectedGarantia)
      // Con extensión elegida: equipos antiguos saltan el paso 4 (protecciones
      // no disponibles) y van directo al resumen; recientes pasan al paso 4.
      const destino = this.equipoAntiguo ? 'ovg-carrito' : 'ovg-protecciones'
      this.$router.push({ name: destino })
    },
    formatPrecio(precio) {
      const num = parseFloat(precio)
      if (Number.isNaN(num)) return precio
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
      }).format(num)
    },
  },
}
</script>

<style scoped>
.ovg-page {
  font-family: 'Noto Sans', sans-serif;
  min-height: 100vh;
  background-color: #f5f6fa;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 80px;
}

.ovg-page__bg {
  /* Sin `opacity`: el PNG ya es una marca de agua (su patrón viene con
     alpha 13/255). Desvanecerlo otra vez acá lo dejaba en 0,62% de
     contraste, o sea invisible en pantalla. */
  position: fixed;
  inset: 0;
  background-image: url('~@/assets/fondo_samtek.png');
  background-size: cover;
  background-position: center;
  pointer-events: none;
  z-index: 0;
}

.ovg-header {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 55px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 162px;
  flex-shrink: 0;
}

.ovg-header__logos {
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;
}

.ovg-header__logo-samtek {
  height: 18px;
  width: auto;
}

.ovg-header__logo-asus {
  height: 18px;
  width: auto;
}

.ovg-header__salir {
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #23201c;
  font-family: 'Noto Sans', sans-serif;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
}

.ovg-subheader {
  position: relative;
  z-index: 1;
  width: 100%;
  background: #0a192f;
  min-height: 195px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 20px;
  text-align: left;
}

/* Alinea el texto con el borde izquierdo de la card del formulario. */
.ovg-subheader__inner {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 1207px;
  max-width: calc(100% - 40px);
}

.ovg-subheader__title {
  font-size: 28px;
  font-weight: 700;
  color: #f5f6fa;
  margin: 0;
}

.ovg-subheader__subtitle {
  font-size: 15px;
  font-weight: 400;
  color: #f5f6fa;
  margin: 0;
  line-height: 1.5;
}

.ovg-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  width: 1207px;
  max-width: calc(100% - 40px);
  margin-top: -20px;
}

.ovg-content >>> .ovg-resumen {
  position: sticky;
  top: 20px;
}

.ovg-card {
  position: relative;
  z-index: 1;
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;
  width: 827px;
  flex-shrink: 0;
  box-shadow: 0px 8px 12px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 24px;
}

@media (max-width: 1247px) {
  .ovg-content {
    flex-direction: column;
    align-items: center;
    width: 827px;
  }

  .ovg-subheader__inner {
    width: 827px;
  }

  .ovg-content >>> .ovg-resumen {
    position: static;
    width: 100%;
  }
}

.ovg-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.ovg-step {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ovg-step__num {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 60px;
  background: #f5f6fa;
  color: #525252;
  font-size: 18px;
  font-weight: 700;
  flex-shrink: 0;
}

.ovg-step__label {
  font-size: 20px;
  font-weight: 700;
  color: #525252;
  white-space: nowrap;
}

.ovg-step--active .ovg-step__num,
.ovg-step--done .ovg-step__num {
  background: #fece2f;
  color: #23201c;
  font-size: 15px;
}

.ovg-step--active .ovg-step__label,
.ovg-step--done .ovg-step__label {
  color: #23201c;
}

.ovg-catalogo__estado {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 15px;
  color: #525252;
  padding: 24px 0;
}

.ovg-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid #d2d2d2;
  border-top-color: #525252;
  border-radius: 50%;
  animation: ovg-spin 0.6s linear infinite;
  flex-shrink: 0;
}

@keyframes ovg-spin {
  to {
    transform: rotate(360deg);
  }
}

.ovg-info-box {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #dddde1;
  border: 1px solid #525252;
  border-radius: 5px;
  padding: 10px;
  font-size: 15px;
  color: #23201c;
}

.ovg-info-box__icon--warn {
  color: #f59e0b;
  flex-shrink: 0;
}

.ovg-link-btn {
  background: none;
  border: none;
  color: #1d4ed8;
  font-family: 'Noto Sans', sans-serif;
  font-size: 15px;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
}

.ovg-sin-garantias {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px 0;
  text-align: center;
}

.ovg-sin-garantias__icon {
  font-size: 48px;
  color: #d2d2d2;
}

.ovg-sin-garantias__text {
  font-size: 15px;
  color: #525252;
  margin: 0;
}

.ovg-estado__icon {
  font-size: 48px;
}

.ovg-estado__icon--warning {
  color: #f59e0b;
}

.ovg-estado__titulo {
  font-size: 18px;
  font-weight: 700;
  color: #23201c;
  margin: 0;
}

.ovg-estado__texto {
  font-size: 15px;
  color: #525252;
  margin: 0;
}

.ovg-link-text {
  background: none;
  border: none;
  color: #23201c;
  font-family: 'Noto Sans', sans-serif;
  font-size: 15px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
}

.ovg-catalogo__grid {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: stretch;
}

.ovg-garantia-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  flex: 0 1 calc(33.333% - 16px);
  min-width: 0;
  background: #ffffff;
  border: 2px solid transparent;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  filter: drop-shadow(0px 8px 9px rgba(0, 0, 0, 0.25));
  transition: border-color 0.15s, filter 0.15s;
  text-align: left;
  font-family: 'Noto Sans', sans-serif;
}

.ovg-garantia-card:hover {
  filter: drop-shadow(0px 8px 9px rgba(0, 0, 0, 0.4));
}

.ovg-garantia-card--selected {
  border-color: #fece2f;
}

.ovg-garantia-card--muted {
  opacity: 0.45;
}

/* Ícono de la card: tamaño de Figma (24x24), alineado a la izquierda. */
.ovg-garantia-card__icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.ovg-garantia-card__nombre {
  font-size: 14px;
  font-weight: 700;
  color: #23201c;
  line-height: 1.3;
}

.ovg-garantia-card__desc {
  font-size: 15px;
  color: #525252;
  line-height: 20px;
  flex: 1;
}

.ovg-garantia-card__precio {
  font-size: 20px;
  font-weight: 700;
  color: #203859;
  margin-top: 4px;
}

.ovg-garantia-card__btn {
  width: 100%;
}

.ovg-garantia-card--selected .ovg-garantia-card__btn {
  opacity: 0.5;
}

.ovg-card__footer {
  display: flex;
  justify-content: flex-end;
}

.ovg-card__footer--split {
  justify-content: space-between;
}

.ovg-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  padding: 10px 20px;
  border-radius: 8px;
  font-family: 'Noto Sans', sans-serif;
  font-size: 15px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: opacity 0.15s;
  white-space: nowrap;
}

.ovg-btn:hover {
  opacity: 0.9;
}

.ovg-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.ovg-btn--primary {
  background: #fece2f;
  color: #23201c;
}

.ovg-btn--secondary {
  background: #f5f6fa;
  color: #23201c;
}

.ovg-btn--outline {
  background: #ffffff;
  color: #23201c;
  border: 1px solid #fece2f;
  width: 100%;
}

.ovg-catalogo__intro {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ovg-catalogo__title {
  font-size: 18px;
  font-weight: 700;
  color: #23201c;
  margin: 0;
}

.ovg-sin-extension {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  width: 100%;
  background: #ffffff;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  filter: drop-shadow(0px 8px 9px rgba(0, 0, 0, 0.25));
  text-align: left;
  font-family: 'Noto Sans', sans-serif;
}

.ovg-sin-extension--selected {
  border-color: #fece2f;
}

/* La opacidad va en los hijos, NO en la card: `opacity` aplica a todo el
   subárbol y un descendiente no puede deshacerla, así que el tooltip navy
   salía al 50% y se veía gris. Excluyéndolo, conserva su color del diseño. */
.ovg-sin-extension--disabled {
  cursor: not-allowed;
}

.ovg-sin-extension--disabled > :not(.ovg-sin-extension__tooltip) {
  opacity: 0.5;
}

.ovg-sin-extension__icon {
  color: #17db94;
  flex-shrink: 0;
}

.ovg-sin-extension__nombre {
  font-size: 15px;
  font-weight: 700;
  color: #23201c;
  line-height: 1.3;
}

.ovg-sin-extension__desc {
  font-size: 15px;
  color: #525252;
  line-height: 20px;
}

.ovg-sin-extension__btn {
  width: 100%;
}

.ovg-sin-extension__tooltip {
  display: none;
}

/* Overlay sobre el tope de la card, no un bloque debajo del botón: en el Figma
   el aviso arranca en la misma y que la card (8264) y mide 787x60, o sea cubre
   sus primeros 60px por encima de la descripción. Absoluto además evita que la
   card cambie de alto al hacer hover. */
.ovg-sin-extension--disabled:hover .ovg-sin-extension__tooltip {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  background: #203859;
  color: #ffffff;
  font-size: 15px;
  line-height: 20px;
  border-radius: 8px;
  padding: 10px;
}

.ovg-catalogo__recuerda {
  font-size: 15px;
  line-height: 20px;
  color: #525252;
  margin: 0;
}

.ovg-catalogo__recuerda-strong {
  color: #ff3838;
}

.ovg-step--muted {
  opacity: 0.5;
}

.ovg-contact-btn {
  position: fixed;
  bottom: 90px;
  right: 70px;
  z-index: 10;
  width: 45px;
  height: 45px;
  background: #fece2f;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #23201c;
  font-size: 20px;
  text-decoration: none;
}

.ovg-page__footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  font-size: 15px;
  font-weight: 400;
  color: #23201c;
  text-align: center;
  margin: 0;
  padding: 12px 0;
  border-top: 1px solid #d2d2d2;
  background: #f5f6fa;
}

/* Mobile progress bar — oculto en desktop */
.ovg-progress {
  display: none;
}

.ovg-progress__track {
  width: 100%;
  height: 8px;
  background: #e3e3e3;
  border-radius: 4px;
  overflow: hidden;
}

.ovg-progress__fill {
  height: 100%;
  background: #fece2f;
  border-radius: 4px;
}

.ovg-progress__label {
  font-size: 14px;
  font-weight: 400;
  color: #525252;
}

/* ============================================================
   MOBILE — max-width: 767px
   ============================================================ */
@media (max-width: 767px) {
  /* Page */
  .ovg-page {
    padding-bottom: 100px;
  }

  /* Header */
  .ovg-header {
    padding: 0 20px;
  }

  /* Sub-header */
  .ovg-subheader {
    min-height: auto;
    padding: 24px 20px;
  }

  .ovg-subheader__inner {
    width: 100%;
  }

  .ovg-subheader__title {
    font-size: 24px;
  }

  .ovg-subheader__subtitle {
    font-size: 14px;
  }

  /* Content */
  .ovg-content {
    width: 100%;
    max-width: 100%;
    margin-top: -20px;
    padding: 0 20px;
    flex-direction: column;
  }

  /* Ocultar panel resumen lateral */
  .ovg-content >>> .ovg-resumen {
    display: none;
  }

  /* Card */
  .ovg-card {
    width: 100%;
    max-width: 375px;
    margin: 0 auto;
    border-radius: 16px;
    padding: 20px;
  }

  /* Desktop step indicator → oculto */
  .ovg-steps {
    display: none;
  }

  /* Mobile progress bar → visible */
  .ovg-progress {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  /* Catálogo grid → columna única */
  .ovg-catalogo__grid {
    flex-direction: column;
    gap: 16px;
  }

  .ovg-garantia-card {
    flex: 0 0 100%;
    width: 100%;
  }

  /* Botones footer → ancho completo con gap */
  .ovg-card__footer--split {
    justify-content: space-between;
    gap: 12px;
  }

  .ovg-card__footer--split .ovg-btn {
    flex: 1;
  }

  /* Siguiente Paso → azul marino en mobile */
  .ovg-card__footer--split .ovg-btn--primary {
    background: #203859;
    color: #ffffff;
  }

  /* Footer de página → oculto en mobile */
  .ovg-page__footer {
    display: none;
  }
}
</style>
